// Underline tab strip (used in ApplicationDetail, Matches, CV source toggle).

interface TabItem {
  key: string;
  label: string;
}

interface Props<K extends string = string> {
  value: K;
  onChange: (key: K) => void;
  items: TabItem[];
}

export default function Tabs<K extends string = string>({ value, onChange, items }: Props<K>) {
  return (
    <div style={{ display: 'flex', gap: 2, marginBottom: 18, borderBottom: '1px solid var(--line)' }}>
      {items.map((t) => {
        const active = t.key === value;
        return (
          <div
            key={t.key}
            onClick={() => onChange(t.key as K)}
            style={{
              padding: '10px 16px',
              fontSize: 13,
              fontWeight: active ? 500 : 400,
              color: active ? 'var(--ink)' : 'var(--ink3)',
              borderBottom: `2px solid ${active ? 'var(--pri)' : 'transparent'}`,
              marginBottom: -1,
              cursor: 'pointer',
            }}
          >
            {t.label}
          </div>
        );
      })}
    </div>
  );
}
